import { render, staticRenderFns } from "./DeliveryConfirmedModal.vue?vue&type=template&id=6cb96aca&scoped=true&"
import script from "./DeliveryConfirmedModal.vue?vue&type=script&lang=ts&"
export * from "./DeliveryConfirmedModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryConfirmedModal.vue?vue&type=style&index=0&id=6cb96aca&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb96aca",
  null
  
)

export default component.exports